import type { ReactElement } from 'react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { FlexiForwardFormField } from '@/App/tiles/FlexiForward/FlexiForwardTile/common/form/FlexiForwardFormField.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useFlexiForwardPropertyChangedHandler } from '@/store/flexi-forward/hooks/useFlexiForwardPropertyChangedHandler.ts';
import type { TcValidation } from '@/store/types.ts';

export function DeliveryDateField({
  tileId,
  validation,
}: {
  tileId: string;
  validation?: TcValidation[];
}): ReactElement {
  const { deliveryDate, deliveryDateTenor } = useFlexiForwardSelector((flexiForward) => ({
    deliveryDate: flexiForward.properties.deliveryDate,
    deliveryDateTenor: flexiForward.properties.deliveryDateTenor,
  }));

  const handleDeliveryDateChanged = useFlexiForwardPropertyChangedHandler<string>(
    tileId,
    'Delivery date change',
    (dateStringOrTenor) => ({ deliveryDate: dateStringOrTenor }),
  );

  return (
    <FlexiForwardFormField formattedMessageId="flexiForwardTile.mainFields.deliveryDate.label">
      <TradeCaptureValidationWrapper validation={validation}>
        <DatePickerWithTenorNext
          date={deliveryDate ?? ''}
          tenor={deliveryDateTenor}
          onChange={handleDeliveryDateChanged}
        />
      </TradeCaptureValidationWrapper>
    </FlexiForwardFormField>
  );
}
